import { type FC, type PropsWithChildren } from 'react';

import styles from './AdfoxTgbBannerWrapper.css';

export const AdfoxTgbBannerWrapper: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles['adfox-tgb-banner-wrapper']}>{children}</div>
);
